import * as SelfServiceUser from './user';

export const SelfServiceUserApi = SelfServiceUser;
